export class UserAlertsResponse {
  data: any[];
  total: number;
  count: number;
  page: number;
  pageCount: number;
}
